import { useEffect, useState } from 'react';
import { YField, YSelect, YBtn } from '../../../../components/yool/YoolPrimitives';
import { YIcon } from '../../../../components/yool/YoolIcons';
import {
  getContratantesColectivos,
  createContratanteColectivo,
} from '../../../../services/supabase/contratantesColectivosService';

export default function PasoContratante({ value, onChange }) {
  const [contratantes, setContratantes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    setLoading(true);
    getContratantesColectivos()
      .then((data) => { if (!ignore) setContratantes(data); })
      .catch((error) => console.warn('Error al obtener contratantes colectivos:', error))
      .finally(() => { if (!ignore) setLoading(false); });
    return () => { ignore = true; };
  }, []);

  const handleCrearRapido = async () => {
    const nombre = window.prompt('Razón social del nuevo contratante:');
    if (!nombre || !nombre.trim()) return;
    const nuevo = await createContratanteColectivo({ tipo: 'empresa', nombre_razon_social: nombre.trim() });
    setContratantes((prev) => [...prev, nuevo]);
    onChange({ contratante_id: String(nuevo.id) });
  };

  return (
    <div className="y-add-bar">
      <YField label="Contratante colectivo">
        <YSelect
          data-testid="select-contratante"
          value={value?.contratante_id || ''}
          onChange={(e) => onChange({ contratante_id: e.target.value })}
          disabled={loading}
        >
          <option value="">{loading ? 'Cargando...' : 'Selecciona contratante'}</option>
          {contratantes.map((ct) => (
            <option key={ct.id} value={ct.id}>{ct.nombre_razon_social}</option>
          ))}
        </YSelect>
      </YField>
      <YBtn variant="outline" size="sm" icon={<YIcon.Plus size={13} />} onClick={handleCrearRapido}>
        Crear contratante nuevo
      </YBtn>
    </div>
  );
}
